import React, {useState, Fragment, useCallback, useReducer, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Form, FormGroup, Input,Row, Col, Label  } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
// import { treatmentplan, plantableColumns } from '../../../../Data/TreatmentSettings';
import CommonModal from '../../../Common/Component/CommonModal';
import RequiredField from '../../../../Constant';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { CreateTreatmentPlan, DeleteTreatmentPlan, DiagnosisList, DiagnosisTypeList, TreatmentPlanList, UpdateTreatmentPlan } from '../../../../apiController';
import DiagnosisType from './DiagnosisType';

import { roles_permissions } from '../../../../Layout/Sidebar/Menu';

const initialState = {
  diagnosis_type_id: '',
  diagnosis_id: '',
  treatmentplan:'',
  id:''
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_DIAGNOSIS_TYPE':
      return { ...state, diagnosis_type_id: action.payload };
    case 'SET_DIAGNOSIS':
      return { ...state, diagnosis_id: action.payload };
    case 'SET_TREATMENTPLAN':
      return { ...state, treatmentplan: action.payload };
    case 'SET_ID':
      return { ...state, id: action.payload };
    case 'RESET_FORM':
      return initialState;
    default:
      return state;
  }
};
const TreatmentPlan = () =>{

  const [Large, setLarge] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [diagnosis, setDiagnoses] = useState([]);
  const [diagnosisTypes, setDiagnosisTypes] = useState([]);
  const [treatmentPlan, setTreatmentPlan] = useState([]);

  const permission = roles_permissions.find(module => module.module_name === 'Treatment Plan')

  const LargeModaltoggle = () => {setLarge(!Large); 
    dispatch({type:'RESET_FORM'})
    // reset({diagnosis:'', diagnosistype:'', treatmentplan:''})
  };

  const [formdata, setFormdata] = useState({});


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const [searchKeyword, setSearchKeyword] = useState('');
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };

  const handleChangetype = (e) => {
    const { name, value } = e.target;
    dispatch({ type: `SET_${name.toUpperCase()}`, payload: value });
    // dispatch({ type: `SET_${name.toUpperCase()}`, payload: value });
    if (name === "DIAGNOSIS_TYPE"){
      fetchDiagnosis(value)
    }

    // console.log(name)
    // console.log(value)
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch({ type: `SET_${name.toUpperCase()}`, payload: value });
    
  };

  const handleEdit = (row) => {
    console.log(row)
    setFormdata({ id: row.id, dname: row.dname , diagnosis: row.name});
    setLarge(!Large);
    fetchDiagnosis(row.diagnosis_type_id)
    dispatch({ type: 'SET_DIAGNOSIS_TYPE', payload: row.diagnosis_type_id });
  dispatch({ type: 'SET_DIAGNOSIS', payload: row.diagnosis_id });
  dispatch({ type: 'SET_TREATMENTPLAN', payload: row.treatment_plan });
  dispatch({ type: 'SET_ID', payload: row.id });
  };

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    // const [data, setData] = useState(treatmentplan);

    const plantableColumns = [
      {
          name: '#',
          selector: row => row['ind'],
          sortable: true,
          center: false,
      },
      {
          name: 'Diagnosis Type',
          selector: row => row['diagnosistype'],
          sortable: true,
          center: true,
      },
      {
          name: 'Diagnosis',
          selector: row => row['diagnosis'],
          sortable: true,
          center: true,
      },
      {
          name: 'Treatment Plan',
          selector: row => row['treatmentPlan'],
          sortable: true,
          center: true,
      },
      // {
      //     name: 'Action',
      //     selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
      //     sortable: false,
      //     center: true,
      // },
  ];

  if(permission?.edit_access){
    plantableColumns.push(
      {
        name: 'Action',
        selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
        sortable: false,
        center: true,
    },
    )
  }
  
   const treatmentplan = treatmentPlan.map((row, ind)=>
      ({
          ind: ind+1,
          id: row.id,
          diagnosistype: row.diagnosis_type_name,
          diagnosis: row.diagnosis_name,
          treatmentPlan: row.treatment_plan,
          action: 
          ({ LargeModaltoggle }) => (
              <span>
                  <Btn
                      attrBtn={{
                          style:  { width: 60, fontSize: 14, padding: 4 },
                          color: 'success',
                          className: 'btn btn-xs',
                          type: 'button',
                          onClick: () => handleEdit(row)
                      }}
                  >
                      Edit
                  </Btn>
              </span>
          )
      })
    );

   

    const handleSaveForm = async () => {  

      const formattedData = {
        diagnosis_type_id: state.diagnosis_type_id,
        diagnosis_id:state.diagnosis_id,
        treatment_plan: state.treatmentplan,
        id: state.id
    };
    // console.log(state)
    // console.log(formattedData)

    try {
      if (state.id) {
          const response = await UpdateTreatmentPlan(formattedData);
          if (response.status === true) {
              toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
              fetchTreatmentPlan()
              

          }
      } else {
          const response = await CreateTreatmentPlan(formattedData);
          if (response.status === true) {
              toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
              fetchTreatmentPlan()
          }
      }
      // fetchDiagnosis();
      LargeModaltoggle();
  } catch (error) {
      toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
  }
      dispatch({type:'RESET_FORM'})
    };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = async () => {
      const result = await SweetAlert.fire({
        title: 'Are you sure you want to delete?',
        cancelButtonText: 'No!',
        confirmButtonText: 'Yes!',
        reverseButtons: true,
        showCancelButton: true,
      });
    
      if (result.isConfirmed) {
        try {
          const selectedIds = selectedRows.map(row => row.id); 
          await Promise.all(selectedIds.map(id => DeleteTreatmentPlan(id)));
          // setDiagnosisTypes(diagnosisTypes.filter(item => !selectedIds.includes(item.id)));
          setSelectedRows([]);
          toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
          fetchTreatmentPlan()
        } catch (error) {
          toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
        }
      }
    };


    const fetchDiagnosis = async (id) => {
      const response = await DiagnosisList();
      if (response.status === true) {
        const filteredId = response.data.filter((item) => item.diagnosis_type.toString() === id.toString());
        setDiagnoses(filteredId);
        // dispatch({ type: 'SET_DIAGNOSIS', payload: filteredId })
  }
    };
  
    const fetchDiagnosisType = async () => {
      const response = await DiagnosisTypeList();
      if (response.status === true) {
        setDiagnosisTypes(response.data);
        // fetchDiagnosis(response.data.id)
      }
    };
    const fetchTreatmentPlan = async () => {
      const response = await TreatmentPlanList();
      if (response.status === true) {
        setTreatmentPlan(response.data);
      }
    };
  
    useEffect(()=>{
      fetchTreatmentPlan()
      fetchDiagnosisType()
    },[])
  return (
    <Card>
      <Breadcrumbs mainTitle='Treatment Plan' parent='Dashboard' title='treatmentplan' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            defaultValue={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search"></i>
            </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
          <div className='card-header-right-icon'>
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            <div className='card-header-right-icon'>
            {permission?.create_access && <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: LargeModaltoggle }}>+ Add Treatment Plan</Btn>}
            <CommonModal isOpen={Large} title={"Diagnosis"} toggler={LargeModaltoggle} size="lg" onSave={handleSaveForm} formdata={formdata}>
              <Row className='d-flex gap-5'>
                <Col sm="12">
                <FormGroup className="mb-3">
                                    <Label htmlFor="exampleFormControlSelect9">{"Diagnosis Type"} <RequiredField/></Label>
                                    <Input type="select" name="DIAGNOSIS_TYPE" className="form-control digits" id="dtype"  value={state.diagnosis_type_id} onChange={handleChangetype} >
                                    <option  value=''>Select Diagnosis Type</option>
                                 
                                    {diagnosisTypes.map((type)=> <option key={type.id} value={type.id}>{type.name}</option>
                                    )}
                                     </Input>
                                   
                                    <span className="text-danger">{errors.diagnosistype && "Diagnosis type is required"}</span>
                                </FormGroup>
                <FormGroup className="mb-3">
                                    <Label htmlFor="exampleFormControlSelect9">{'Diagnosis'} <RequiredField/></Label>
                                    <Input type="select" name="DIAGNOSIS" className="form-control digits" id="dname"  value={state.diagnosis_id} onChange={handleChange} >
                                    <option  value=''>Select Diagnosis</option>
                                 
                                    {diagnosis.map((type)=> <option key={type.id} value={type.id}>{type.name}</option>
                                    )}
                                     </Input>
                                   
                                    <span className="text-danger">{errors.diagnosis && "Diagnosis is required"}</span>
                                </FormGroup>
                <FormGroup className="mb-3">
                      <Label htmlFor="fname">{"Treatment Plan"} <RequiredField/></Label>
                      <input className={`form-control ${errors.treatmentplan && "is-invalid"}`} id="treatmentplan" type="text" name="treatmentplan" value={state.treatmentplan} onChange={handleChange}/>
                      <span className="text-danger">{errors.treatmentplan && "Diagnosis is required"}</span>
                    </FormGroup>
            </Col>
            </Row>
            </CommonModal>
          </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={treatmentplan}
                columns={plantableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows = {permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
  );
}

export default TreatmentPlan